import { render, staticRenderFns } from "./license-rejectList.vue?vue&type=template&id=c068ecfe&scoped=true&"
import script from "./license-rejectList.vue?vue&type=script&lang=js&"
export * from "./license-rejectList.vue?vue&type=script&lang=js&"
import style0 from "./license-rejectList.vue?vue&type=style&index=0&id=c068ecfe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c068ecfe",
  null
  
)

export default component.exports